import { ucFirst } from "@kateinnovations/javascript-helpers";
import defaultConfig from "config/constants/defaultConfig";

const formData = ({ formatMessage }) => {
    return {
        attributes: {
            method: "post",
            name: "login-form",
            autoComplete: "off",
            "data-required": true,
            action: defaultConfig.api.auth.login,
            noValidate: true,
        },
        fieldsets: [
            {
                id: 1,
                caption: null,
                disabled: false,
                form: null,
                name: null,
                elements: {
                    email: {
                        id: 1,
                        label: {
                            for: "login-username",
                            text: ucFirst(formatMessage({ id: "login.username" })),
                        },
                        node: "input",
                        attributes: {
                            name: "username",
                            type: "text",
                            placeholder: formatMessage({ id: "login.username" }),
                            autoComplete: "username",
                            "data-required": true,
                            "data-validation-types": JSON.stringify({
                                hasMinimalAndMaximalCharacters: { minCharacters: 0, maxCharacters: 256 },
                            }),
                            state: "isEmpty",
                        },
                        state: "isEmpty",
                    },
                    password: {
                        id: 2,
                        label: {
                            for: "login-password",
                            text: ucFirst(formatMessage({ id: "login.password" })),
                        },
                        node: "input",
                        attributes: {
                            name: "password",
                            type: "password",
                            placeholder: ucFirst(formatMessage({ id: "login.password" })),
                            autoComplete: "current-password",
                            "data-required": true,
                            "data-validation-types": JSON.stringify({
                                hasMinimalAndMaximalCharacters: { minCharacters: 0, maxCharacters: 256 },
                            }),
                            state: "isEmpty",
                        },
                        state: "isEmpty",
                    },
                },
            },
            {
                id: 2,
                caption: null,
                disabled: false,
                form: null,
                name: null,
                variant: "row-reverse",
                elements: {
                    submit: {
                        id: 3,
                        node: "button",
                        icon: "submit",
                        text: ucFirst(formatMessage({ id: "login.login" })),
                        attributes: {
                            type: "submit",
                            "aria-label": ucFirst(formatMessage({ id: "login.login" })),
                            variant: "text-only",
                            disabled: true,
                        },
                        noBorder: true,
                        align: "end",
                        color: "color-grey",
                    },
                },
            },
        ],
    };
};

export default formData;
